import { useCallback, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { debounce } from "lodash";
import { Select } from "antd";
import userRepo from "../../API/LayoutApi/user.repo";

type TUserValue = string | string[];

function UserSelect({
  value,
  onChange,
  multiple = false,
}: {
  value?: TUserValue;
  onChange?(value: TUserValue): void;
  multiple?: boolean;
} = {}) {
  const [search, setSearch] = useState("");

  const { isFetching, data } = useQuery({
    queryKey: ["users", search],
    queryFn: () => userRepo.getUsers({ page: 1, perPage: 10, search }),
    refetchOnWindowFocus: false,
  });

  const [searchValue, setSearchValue] = useState("");

  const options = useMemo(() => {
    if (data?.data) {
      return data.data.map((user) => ({
        label: user.first_name + " " + user.second_name,
        value: user.id,
      }));
    }
    return [];
  }, [data]);

  const debounceChangeSearch = useCallback(debounce(setSearch, 500), []);

  function onSearchFromSelect(val: string) {
    setSearchValue(val);
    debounceChangeSearch(val);
  }

  const filterOption = useCallback(
    (input: string, option?: { label: string; value: string }) =>
      (option?.label ?? "").toLowerCase().includes(input.toLowerCase()),
    []
  );

  return (
    <Select
      showSearch
      placeholder="Search user"
      optionFilterProp="children"
      searchValue={searchValue}
      value={value}
      onChange={onChange}
      onSearch={onSearchFromSelect}
      options={options}
      filterOption={filterOption}
      loading={isFetching}
      allowClear
      mode={multiple ? "multiple" : undefined}
    />
  );
}

export default UserSelect;
